// This file is AUTOGENERATED, do not edit it manually!!!

import { activityList as activityListde } from './activityListResx.de';
import { activityList as activityListen } from './activityListResx.en';
import { activityList as activityListen_risk } from './activityListResx.en_risk';
import { activityList as activityListes } from './activityListResx.es';
import { activityList as activityListfr } from './activityListResx.fr';
import { activityList as activityListit } from './activityListResx.it';
import { activityList as activityListnl } from './activityListResx.nl';
import { activityList as activityListpl } from './activityListResx.pl';
import { activityList as activityListpt } from './activityListResx.pt';
import { activityList as activityListru } from './activityListResx.ru';
import { activityList as activityListsk } from './activityListResx.sk';
import { activityList as activityListsv } from './activityListResx.sv';
import { activityList as activityListtr } from './activityListResx.tr';

const langMap: { [k: string]: Partial<typeof activityListen> } = {
    de: activityListde,
    en: activityListen,
    en_risk: activityListen_risk,
    es: activityListes,
    fr: activityListfr,
    it: activityListit,
    nl: activityListnl,
    pl: activityListpl,
    pt: activityListpt,
    ru: activityListru,
    sk: activityListsk,
    sv: activityListsv,
    tr: activityListtr,
};

/* tslint:disable: max-line-length */
export const activityListResx = {
    get Activities() {
        return langMap[ep.resxCulture].Activities || langMap.en.Activities;
    },
    get Activities_Text() {
        return langMap[ep.resxCulture].Activities_Text || langMap.en.Activities_Text;
    },
    get activities_without_dates() {
        return langMap[ep.resxCulture].activities_without_dates || langMap.en.activities_without_dates;
    },
    get Activity() {
        return langMap[ep.resxCulture].Activity || langMap.en.Activity;
    },
    get Activity_Billing() {
        return langMap[ep.resxCulture].Activity_Billing || langMap.en.Activity_Billing;
    },
    get Activity_Cost() {
        return langMap[ep.resxCulture].Activity_Cost || langMap.en.Activity_Cost;
    },
    get Activity_CostVariance() {
        return langMap[ep.resxCulture].Activity_CostVariance || langMap.en.Activity_CostVariance;
    },
    get Activity_HoursLeft() {
        return langMap[ep.resxCulture].Activity_HoursLeft || langMap.en.Activity_HoursLeft;
    },
    get Activity_InternalCost() {
        return langMap[ep.resxCulture].Activity_InternalCost || langMap.en.Activity_InternalCost;
    },
    get Activity_Profit() {
        return langMap[ep.resxCulture].Activity_Profit || langMap.en.Activity_Profit;
    },
    get Add_Task() {
        return langMap[ep.resxCulture].Add_Task || langMap.en.Add_Task;
    },
    get AITaskGeneration_projectName() {
        return langMap[ep.resxCulture].AITaskGeneration_projectName || langMap.en.AITaskGeneration_projectName;
    },
    get AITaskGeneration_retry() {
        return langMap[ep.resxCulture].AITaskGeneration_retry || langMap.en.AITaskGeneration_retry;
    },
    get AITaskGeneration_title() {
        return langMap[ep.resxCulture].AITaskGeneration_title || langMap.en.AITaskGeneration_title;
    },
    get All_Saved_Views() {
        return langMap[ep.resxCulture].All_Saved_Views || langMap.en.All_Saved_Views;
    },
    get Apply_Text() {
        return langMap[ep.resxCulture].Apply_Text || langMap.en.Apply_Text;
    },
    get apply_wbs_sorting() {
        return langMap[ep.resxCulture].apply_wbs_sorting || langMap.en.apply_wbs_sorting;
    },
    get Archive_Success_Message() {
        return langMap[ep.resxCulture].Archive_Success_Message || langMap.en.Archive_Success_Message;
    },
    get archived_label() {
        return langMap[ep.resxCulture].archived_label || langMap.en.archived_label;
    },
    get Baseline_Text() {
        return langMap[ep.resxCulture].Baseline_Text || langMap.en.Baseline_Text;
    },
    get Board_CreateTaskInProjectPlaceholder() {
        return langMap[ep.resxCulture].Board_CreateTaskInProjectPlaceholder || langMap.en.Board_CreateTaskInProjectPlaceholder;
    },
    get Board_ShowMore() {
        return langMap[ep.resxCulture].Board_ShowMore || langMap.en.Board_ShowMore;
    },
    get Browse_Views() {
        return langMap[ep.resxCulture].Browse_Views || langMap.en.Browse_Views;
    },
    get Budget_problem_project() {
        return langMap[ep.resxCulture].Budget_problem_project || langMap.en.Budget_problem_project;
    },
    get Budget_problem_task() {
        return langMap[ep.resxCulture].Budget_problem_task || langMap.en.Budget_problem_task;
    },
    get Budget_Text() {
        return langMap[ep.resxCulture].Budget_Text || langMap.en.Budget_Text;
    },
    get Budget_warning_project() {
        return langMap[ep.resxCulture].Budget_warning_project || langMap.en.Budget_warning_project;
    },
    get Budget_warning_task() {
        return langMap[ep.resxCulture].Budget_warning_task || langMap.en.Budget_warning_task;
    },
    get By_Text() {
        return langMap[ep.resxCulture].By_Text || langMap.en.By_Text;
    },
    get change_activity_type_to_label() {
        return langMap[ep.resxCulture].change_activity_type_to_label || langMap.en.change_activity_type_to_label;
    },
    get ChooseTemplateDropdownLabel() {
        return langMap[ep.resxCulture].ChooseTemplateDropdownLabel || langMap.en.ChooseTemplateDropdownLabel;
    },
    get Counter() {
        return langMap[ep.resxCulture].Counter || langMap.en.Counter;
    },
    get CPI_Problem() {
        return langMap[ep.resxCulture].CPI_Problem || langMap.en.CPI_Problem;
    },
    get Create() {
        return langMap[ep.resxCulture].Create || langMap.en.Create;
    },
    get create_snapshot() {
        return langMap[ep.resxCulture].create_snapshot || langMap.en.create_snapshot;
    },
    get CreateNewItem() {
        return langMap[ep.resxCulture].CreateNewItem || langMap.en.CreateNewItem;
    },
    get CreateProject_Tooltip() {
        return langMap[ep.resxCulture].CreateProject_Tooltip || langMap.en.CreateProject_Tooltip;
    },
    get CriticalPath_Text() {
        return langMap[ep.resxCulture].CriticalPath_Text || langMap.en.CriticalPath_Text;
    },
    get CustomField_No() {
        return langMap[ep.resxCulture].CustomField_No || langMap.en.CustomField_No;
    },
    get CustomField_Yes() {
        return langMap[ep.resxCulture].CustomField_Yes || langMap.en.CustomField_Yes;
    },
    get DayPluralFormat() {
        return langMap[ep.resxCulture].DayPluralFormat || langMap.en.DayPluralFormat;
    },
    get Default_Text() {
        return langMap[ep.resxCulture].Default_Text || langMap.en.Default_Text;
    },
    get Delete_Confirmation_Title() {
        return langMap[ep.resxCulture].Delete_Confirmation_Title || langMap.en.Delete_Confirmation_Title;
    },
    get Delete_Entity_Confirmation_Archive_Description() {
        return langMap[ep.resxCulture].Delete_Entity_Confirmation_Archive_Description || langMap.en.Delete_Entity_Confirmation_Archive_Description;
    },
    get Delete_Project_Title() {
        return langMap[ep.resxCulture].Delete_Project_Title || langMap.en.Delete_Project_Title;
    },
    get Delete_Task_Title() {
        return langMap[ep.resxCulture].Delete_Task_Title || langMap.en.Delete_Task_Title;
    },
    get Delete_Text() {
        return langMap[ep.resxCulture].Delete_Text || langMap.en.Delete_Text;
    },
    get DeleteEntityConfirmation() {
        return langMap[ep.resxCulture].DeleteEntityConfirmation || langMap.en.DeleteEntityConfirmation;
    },
    get DeletePermanently() {
        return langMap[ep.resxCulture].DeletePermanently || langMap.en.DeletePermanently;
    },
    get DeleteVerb() {
        return langMap[ep.resxCulture].DeleteVerb || langMap.en.DeleteVerb;
    },
    get DeleteVerbActivity() {
        return langMap[ep.resxCulture].DeleteVerbActivity || langMap.en.DeleteVerbActivity;
    },
    get Dependency_AddMore_Text() {
        return langMap[ep.resxCulture].Dependency_AddMore_Text || langMap.en.Dependency_AddMore_Text;
    },
    get Dependency_Cancel() {
        return langMap[ep.resxCulture].Dependency_Cancel || langMap.en.Dependency_Cancel;
    },
    get Dependency_Choose() {
        return langMap[ep.resxCulture].Dependency_Choose || langMap.en.Dependency_Choose;
    },
    get Dependency_days() {
        return langMap[ep.resxCulture].Dependency_days || langMap.en.Dependency_days;
    },
    get Dependency_DelayWarningExample() {
        return langMap[ep.resxCulture].Dependency_DelayWarningExample || langMap.en.Dependency_DelayWarningExample;
    },
    get Dependency_DelayWarningText() {
        return langMap[ep.resxCulture].Dependency_DelayWarningText || langMap.en.Dependency_DelayWarningText;
    },
    get Dependency_DependencyCycle() {
        return langMap[ep.resxCulture].Dependency_DependencyCycle || langMap.en.Dependency_DependencyCycle;
    },
    get Dependency_DependencyType_Text() {
        return langMap[ep.resxCulture].Dependency_DependencyType_Text || langMap.en.Dependency_DependencyType_Text;
    },
    get Dependency_DependsOn_Text() {
        return langMap[ep.resxCulture].Dependency_DependsOn_Text || langMap.en.Dependency_DependsOn_Text;
    },
    get Dependency_FinishToStart_Minus1() {
        return langMap[ep.resxCulture].Dependency_FinishToStart_Minus1 || langMap.en.Dependency_FinishToStart_Minus1;
    },
    get Dependency_FinishToStart_Minus1_Pattern() {
        return langMap[ep.resxCulture].Dependency_FinishToStart_Minus1_Pattern || langMap.en.Dependency_FinishToStart_Minus1_Pattern;
    },
    get Dependency_FinishToStart_Minus2() {
        return langMap[ep.resxCulture].Dependency_FinishToStart_Minus2 || langMap.en.Dependency_FinishToStart_Minus2;
    },
    get Dependency_FinishToStart_Minus2_Pattern() {
        return langMap[ep.resxCulture].Dependency_FinishToStart_Minus2_Pattern || langMap.en.Dependency_FinishToStart_Minus2_Pattern;
    },
    get Dependency_FinishToStart_Plus0() {
        return langMap[ep.resxCulture].Dependency_FinishToStart_Plus0 || langMap.en.Dependency_FinishToStart_Plus0;
    },
    get Dependency_FinishToStart_Plus0_Pattern() {
        return langMap[ep.resxCulture].Dependency_FinishToStart_Plus0_Pattern || langMap.en.Dependency_FinishToStart_Plus0_Pattern;
    },
    get Dependency_FinishToStart_Plus1() {
        return langMap[ep.resxCulture].Dependency_FinishToStart_Plus1 || langMap.en.Dependency_FinishToStart_Plus1;
    },
    get Dependency_FinishToStart_Plus1_Pattern() {
        return langMap[ep.resxCulture].Dependency_FinishToStart_Plus1_Pattern || langMap.en.Dependency_FinishToStart_Plus1_Pattern;
    },
    get Dependency_FinishToStart_Plus2() {
        return langMap[ep.resxCulture].Dependency_FinishToStart_Plus2 || langMap.en.Dependency_FinishToStart_Plus2;
    },
    get Dependency_FinishToStart_Plus2_Pattern() {
        return langMap[ep.resxCulture].Dependency_FinishToStart_Plus2_Pattern || langMap.en.Dependency_FinishToStart_Plus2_Pattern;
    },
    get Dependency_FinishWhenStarted_Text() {
        return langMap[ep.resxCulture].Dependency_FinishWhenStarted_Text || langMap.en.Dependency_FinishWhenStarted_Text;
    },
    get Dependency_FinishWhenStarted_Title() {
        return langMap[ep.resxCulture].Dependency_FinishWhenStarted_Title || langMap.en.Dependency_FinishWhenStarted_Title;
    },
    get Dependency_Lag_Text() {
        return langMap[ep.resxCulture].Dependency_Lag_Text || langMap.en.Dependency_Lag_Text;
    },
    get Dependency_ParentChildRelationship() {
        return langMap[ep.resxCulture].Dependency_ParentChildRelationship || langMap.en.Dependency_ParentChildRelationship;
    },
    get Dependency_Reason() {
        return langMap[ep.resxCulture].Dependency_Reason || langMap.en.Dependency_Reason;
    },
    get Dependency_Remove_Text() {
        return langMap[ep.resxCulture].Dependency_Remove_Text || langMap.en.Dependency_Remove_Text;
    },
    get Dependency_RemoveSingleDependency_Text() {
        return langMap[ep.resxCulture].Dependency_RemoveSingleDependency_Text || langMap.en.Dependency_RemoveSingleDependency_Text;
    },
    get Dependency_Save() {
        return langMap[ep.resxCulture].Dependency_Save || langMap.en.Dependency_Save;
    },
    get Dependency_SelectDependsOn_Text() {
        return langMap[ep.resxCulture].Dependency_SelectDependsOn_Text || langMap.en.Dependency_SelectDependsOn_Text;
    },
    get Dependency_StartsWhenFinished_Text() {
        return langMap[ep.resxCulture].Dependency_StartsWhenFinished_Text || langMap.en.Dependency_StartsWhenFinished_Text;
    },
    get Dependency_StartsWhenFinished_Title() {
        return langMap[ep.resxCulture].Dependency_StartsWhenFinished_Title || langMap.en.Dependency_StartsWhenFinished_Title;
    },
    get Dependency_StartsWhenStarted_Text() {
        return langMap[ep.resxCulture].Dependency_StartsWhenStarted_Text || langMap.en.Dependency_StartsWhenStarted_Text;
    },
    get Dependency_StartsWhenStarted_Title() {
        return langMap[ep.resxCulture].Dependency_StartsWhenStarted_Title || langMap.en.Dependency_StartsWhenStarted_Title;
    },
    get Dependency_StartToFinish_Minus1() {
        return langMap[ep.resxCulture].Dependency_StartToFinish_Minus1 || langMap.en.Dependency_StartToFinish_Minus1;
    },
    get Dependency_StartToFinish_Minus1_Pattern() {
        return langMap[ep.resxCulture].Dependency_StartToFinish_Minus1_Pattern || langMap.en.Dependency_StartToFinish_Minus1_Pattern;
    },
    get Dependency_StartToFinish_Minus2() {
        return langMap[ep.resxCulture].Dependency_StartToFinish_Minus2 || langMap.en.Dependency_StartToFinish_Minus2;
    },
    get Dependency_StartToFinish_Minus2_Pattern() {
        return langMap[ep.resxCulture].Dependency_StartToFinish_Minus2_Pattern || langMap.en.Dependency_StartToFinish_Minus2_Pattern;
    },
    get Dependency_StartToFinish_Plus0() {
        return langMap[ep.resxCulture].Dependency_StartToFinish_Plus0 || langMap.en.Dependency_StartToFinish_Plus0;
    },
    get Dependency_StartToFinish_Plus0_Pattern() {
        return langMap[ep.resxCulture].Dependency_StartToFinish_Plus0_Pattern || langMap.en.Dependency_StartToFinish_Plus0_Pattern;
    },
    get Dependency_StartToFinish_Plus1() {
        return langMap[ep.resxCulture].Dependency_StartToFinish_Plus1 || langMap.en.Dependency_StartToFinish_Plus1;
    },
    get Dependency_StartToFinish_Plus1_Pattern() {
        return langMap[ep.resxCulture].Dependency_StartToFinish_Plus1_Pattern || langMap.en.Dependency_StartToFinish_Plus1_Pattern;
    },
    get Dependency_StartToFinish_Plus2() {
        return langMap[ep.resxCulture].Dependency_StartToFinish_Plus2 || langMap.en.Dependency_StartToFinish_Plus2;
    },
    get Dependency_StartToFinish_Plus2_Pattern() {
        return langMap[ep.resxCulture].Dependency_StartToFinish_Plus2_Pattern || langMap.en.Dependency_StartToFinish_Plus2_Pattern;
    },
    get Dependency_StartToStart_Minus1() {
        return langMap[ep.resxCulture].Dependency_StartToStart_Minus1 || langMap.en.Dependency_StartToStart_Minus1;
    },
    get Dependency_StartToStart_Minus1_Pattern() {
        return langMap[ep.resxCulture].Dependency_StartToStart_Minus1_Pattern || langMap.en.Dependency_StartToStart_Minus1_Pattern;
    },
    get Dependency_StartToStart_Minus2() {
        return langMap[ep.resxCulture].Dependency_StartToStart_Minus2 || langMap.en.Dependency_StartToStart_Minus2;
    },
    get Dependency_StartToStart_Minus2_Pattern() {
        return langMap[ep.resxCulture].Dependency_StartToStart_Minus2_Pattern || langMap.en.Dependency_StartToStart_Minus2_Pattern;
    },
    get Dependency_StartToStart_Plus0() {
        return langMap[ep.resxCulture].Dependency_StartToStart_Plus0 || langMap.en.Dependency_StartToStart_Plus0;
    },
    get Dependency_StartToStart_Plus0_Pattern() {
        return langMap[ep.resxCulture].Dependency_StartToStart_Plus0_Pattern || langMap.en.Dependency_StartToStart_Plus0_Pattern;
    },
    get Dependency_StartToStart_Plus1() {
        return langMap[ep.resxCulture].Dependency_StartToStart_Plus1 || langMap.en.Dependency_StartToStart_Plus1;
    },
    get Dependency_StartToStart_Plus1_Pattern() {
        return langMap[ep.resxCulture].Dependency_StartToStart_Plus1_Pattern || langMap.en.Dependency_StartToStart_Plus1_Pattern;
    },
    get Dependency_StartToStart_Plus2() {
        return langMap[ep.resxCulture].Dependency_StartToStart_Plus2 || langMap.en.Dependency_StartToStart_Plus2;
    },
    get Dependency_StartToStart_Plus2_Pattern() {
        return langMap[ep.resxCulture].Dependency_StartToStart_Plus2_Pattern || langMap.en.Dependency_StartToStart_Plus2_Pattern;
    },
    get Dependency_Warning_Text() {
        return langMap[ep.resxCulture].Dependency_Warning_Text || langMap.en.Dependency_Warning_Text;
    },
    get Details() {
        return langMap[ep.resxCulture].Details || langMap.en.Details;
    },
    get Edit_Text() {
        return langMap[ep.resxCulture].Edit_Text || langMap.en.Edit_Text;
    },
    get empty_sorting_list() {
        return langMap[ep.resxCulture].empty_sorting_list || langMap.en.empty_sorting_list;
    },
    get EnterProjectName() {
        return langMap[ep.resxCulture].EnterProjectName || langMap.en.EnterProjectName;
    },
    get EnterTaskName() {
        return langMap[ep.resxCulture].EnterTaskName || langMap.en.EnterTaskName;
    },
    get EnterViewName_Text() {
        return langMap[ep.resxCulture].EnterViewName_Text || langMap.en.EnterViewName_Text;
    },
    get Error_DragAndDrop_BreakingHierarchy() {
        return langMap[ep.resxCulture].Error_DragAndDrop_BreakingHierarchy || langMap.en.Error_DragAndDrop_BreakingHierarchy;
    },
    get Error_DragAndDrop_ChangeParentInFlattenView() {
        return langMap[ep.resxCulture].Error_DragAndDrop_ChangeParentInFlattenView || langMap.en.Error_DragAndDrop_ChangeParentInFlattenView;
    },
    get Error_DragAndDrop_CycleDependencies() {
        return langMap[ep.resxCulture].Error_DragAndDrop_CycleDependencies || langMap.en.Error_DragAndDrop_CycleDependencies;
    },
    get Error_DragAndDrop_DifferentProjects() {
        return langMap[ep.resxCulture].Error_DragAndDrop_DifferentProjects || langMap.en.Error_DragAndDrop_DifferentProjects;
    },
    get Error_DragAndDrop_ReorderWithSorting() {
        return langMap[ep.resxCulture].Error_DragAndDrop_ReorderWithSorting || langMap.en.Error_DragAndDrop_ReorderWithSorting;
    },
    get Error_PresetNotFound() {
        return langMap[ep.resxCulture].Error_PresetNotFound || langMap.en.Error_PresetNotFound;
    },
    get EstimatedHours_problem() {
        return langMap[ep.resxCulture].EstimatedHours_problem || langMap.en.EstimatedHours_problem;
    },
    get export_activities() {
        return langMap[ep.resxCulture].export_activities || langMap.en.export_activities;
    },
    get export_activities_expanded_only() {
        return langMap[ep.resxCulture].export_activities_expanded_only || langMap.en.export_activities_expanded_only;
    },
    get Export_Activities_Text() {
        return langMap[ep.resxCulture].Export_Activities_Text || langMap.en.Export_Activities_Text;
    },
    get Export_Import_Text() {
        return langMap[ep.resxCulture].Export_Import_Text || langMap.en.Export_Import_Text;
    },
    get export_projects() {
        return langMap[ep.resxCulture].export_projects || langMap.en.export_projects;
    },
    get Export_Projects_Text() {
        return langMap[ep.resxCulture].Export_Projects_Text || langMap.en.Export_Projects_Text;
    },
    get flat_view() {
        return langMap[ep.resxCulture].flat_view || langMap.en.flat_view;
    },
    get From() {
        return langMap[ep.resxCulture].From || langMap.en.From;
    },
    get Group_By_Portfolio() {
        return langMap[ep.resxCulture].Group_By_Portfolio || langMap.en.Group_By_Portfolio;
    },
    get group_by_project() {
        return langMap[ep.resxCulture].group_by_project || langMap.en.group_by_project;
    },
    get Hide_Counter() {
        return langMap[ep.resxCulture].Hide_Counter || langMap.en.Hide_Counter;
    },
    get Hide_Text() {
        return langMap[ep.resxCulture].Hide_Text || langMap.en.Hide_Text;
    },
    get hide_uncategorized_tasks() {
        return langMap[ep.resxCulture].hide_uncategorized_tasks || langMap.en.hide_uncategorized_tasks;
    },
    get Hours_Short_Text() {
        return langMap[ep.resxCulture].Hours_Short_Text || langMap.en.Hours_Short_Text;
    },
    get Import_CSV_Text() {
        return langMap[ep.resxCulture].Import_CSV_Text || langMap.en.Import_CSV_Text;
    },
    get Import_MSProject_Text() {
        return langMap[ep.resxCulture].Import_MSProject_Text || langMap.en.Import_MSProject_Text;
    },
    get Import_Text() {
        return langMap[ep.resxCulture].Import_Text || langMap.en.Import_Text;
    },
    get Indicator_Counter_Snooze_Tooltip() {
        return langMap[ep.resxCulture].Indicator_Counter_Snooze_Tooltip || langMap.en.Indicator_Counter_Snooze_Tooltip;
    },
    get Indicator_Counter_Tooltip() {
        return langMap[ep.resxCulture].Indicator_Counter_Tooltip || langMap.en.Indicator_Counter_Tooltip;
    },
    get Indicator_Project_Tooltip() {
        return langMap[ep.resxCulture].Indicator_Project_Tooltip || langMap.en.Indicator_Project_Tooltip;
    },
    get Indicator_Snooze_1_Week() {
        return langMap[ep.resxCulture].Indicator_Snooze_1_Week || langMap.en.Indicator_Snooze_1_Week;
    },
    get Indicator_Snooze_4_Hours() {
        return langMap[ep.resxCulture].Indicator_Snooze_4_Hours || langMap.en.Indicator_Snooze_4_Hours;
    },
    get Indicator_Snooze_Cancel() {
        return langMap[ep.resxCulture].Indicator_Snooze_Cancel || langMap.en.Indicator_Snooze_Cancel;
    },
    get Indicator_Snooze_Custom() {
        return langMap[ep.resxCulture].Indicator_Snooze_Custom || langMap.en.Indicator_Snooze_Custom;
    },
    get Indicator_Snooze_Custom_Modal_Header() {
        return langMap[ep.resxCulture].Indicator_Snooze_Custom_Modal_Header || langMap.en.Indicator_Snooze_Custom_Modal_Header;
    },
    get Indicator_Snooze_Forever() {
        return langMap[ep.resxCulture].Indicator_Snooze_Forever || langMap.en.Indicator_Snooze_Forever;
    },
    get Indicator_Snooze_Menu_Text() {
        return langMap[ep.resxCulture].Indicator_Snooze_Menu_Text || langMap.en.Indicator_Snooze_Menu_Text;
    },
    get Indicator_Snooze_Message() {
        return langMap[ep.resxCulture].Indicator_Snooze_Message || langMap.en.Indicator_Snooze_Message;
    },
    get Indicator_Snooze_Message_Forever() {
        return langMap[ep.resxCulture].Indicator_Snooze_Message_Forever || langMap.en.Indicator_Snooze_Message_Forever;
    },
    get Indicator_Snooze_Until_Tomorrow() {
        return langMap[ep.resxCulture].Indicator_Snooze_Until_Tomorrow || langMap.en.Indicator_Snooze_Until_Tomorrow;
    },
    get Indicator_Task_Tooltip() {
        return langMap[ep.resxCulture].Indicator_Task_Tooltip || langMap.en.Indicator_Task_Tooltip;
    },
    get Learn_More_Text() {
        return langMap[ep.resxCulture].Learn_More_Text || langMap.en.Learn_More_Text;
    },
    get Loading_Text() {
        return langMap[ep.resxCulture].Loading_Text || langMap.en.Loading_Text;
    },
    get More_Tasks() {
        return langMap[ep.resxCulture].More_Tasks || langMap.en.More_Tasks;
    },
    get MoreActions_AddActivity() {
        return langMap[ep.resxCulture].MoreActions_AddActivity || langMap.en.MoreActions_AddActivity;
    },
    get MoreActions_AddAIActivities() {
        return langMap[ep.resxCulture].MoreActions_AddAIActivities || langMap.en.MoreActions_AddAIActivities;
    },
    get MoreActions_AddNextActivity() {
        return langMap[ep.resxCulture].MoreActions_AddNextActivity || langMap.en.MoreActions_AddNextActivity;
    },
    get MoreActions_AddSubActivity() {
        return langMap[ep.resxCulture].MoreActions_AddSubActivity || langMap.en.MoreActions_AddSubActivity;
    },
    get MoreActions_SaveProjectAsTemplate() {
        return langMap[ep.resxCulture].MoreActions_SaveProjectAsTemplate || langMap.en.MoreActions_SaveProjectAsTemplate;
    },
    get MoreActions_SetAsMilestone() {
        return langMap[ep.resxCulture].MoreActions_SetAsMilestone || langMap.en.MoreActions_SetAsMilestone;
    },
    get MoreActions_UnsetAsMilestone() {
        return langMap[ep.resxCulture].MoreActions_UnsetAsMilestone || langMap.en.MoreActions_UnsetAsMilestone;
    },
    get My_Presets() {
        return langMap[ep.resxCulture].My_Presets || langMap.en.My_Presets;
    },
    get My_Text() {
        return langMap[ep.resxCulture].My_Text || langMap.en.My_Text;
    },
    get MyPresetName_Text() {
        return langMap[ep.resxCulture].MyPresetName_Text || langMap.en.MyPresetName_Text;
    },
    get NewProject() {
        return langMap[ep.resxCulture].NewProject || langMap.en.NewProject;
    },
    get NewProjectBasedOn() {
        return langMap[ep.resxCulture].NewProjectBasedOn || langMap.en.NewProjectBasedOn;
    },
    get NewTask() {
        return langMap[ep.resxCulture].NewTask || langMap.en.NewTask;
    },
    get no_custom_field_value_label() {
        return langMap[ep.resxCulture].no_custom_field_value_label || langMap.en.no_custom_field_value_label;
    },
    get No_Portfolio() {
        return langMap[ep.resxCulture].No_Portfolio || langMap.en.No_Portfolio;
    },
    get no_project_custom_fields_created_text() {
        return langMap[ep.resxCulture].no_project_custom_fields_created_text || langMap.en.no_project_custom_fields_created_text;
    },
    get No_Templates_Text() {
        return langMap[ep.resxCulture].No_Templates_Text || langMap.en.No_Templates_Text;
    },
    get NoSavedViews_Text() {
        return langMap[ep.resxCulture].NoSavedViews_Text || langMap.en.NoSavedViews_Text;
    },
    get Of() {
        return langMap[ep.resxCulture].Of || langMap.en.Of;
    },
    get old_sort_az() {
        return langMap[ep.resxCulture].old_sort_az || langMap.en.old_sort_az;
    },
    get old_sort_za() {
        return langMap[ep.resxCulture].old_sort_za || langMap.en.old_sort_za;
    },
    get parent_activities() {
        return langMap[ep.resxCulture].parent_activities || langMap.en.parent_activities;
    },
    get Portfolios_Text() {
        return langMap[ep.resxCulture].Portfolios_Text || langMap.en.Portfolios_Text;
    },
    get preset_delete() {
        return langMap[ep.resxCulture].preset_delete || langMap.en.preset_delete;
    },
    get preset_delete_confirmation() {
        return langMap[ep.resxCulture].preset_delete_confirmation || langMap.en.preset_delete_confirmation;
    },
    get preset_rename() {
        return langMap[ep.resxCulture].preset_rename || langMap.en.preset_rename;
    },
    get preset_save() {
        return langMap[ep.resxCulture].preset_save || langMap.en.preset_save;
    },
    get preset_saveAs() {
        return langMap[ep.resxCulture].preset_saveAs || langMap.en.preset_saveAs;
    },
    get preset_share() {
        return langMap[ep.resxCulture].preset_share || langMap.en.preset_share;
    },
    get preset_unshare_confirmation() {
        return langMap[ep.resxCulture].preset_unshare_confirmation || langMap.en.preset_unshare_confirmation;
    },
    get Project() {
        return langMap[ep.resxCulture].Project || langMap.en.Project;
    },
    get Project_ActualBudgetProfitability() {
        return langMap[ep.resxCulture].Project_ActualBudgetProfitability || langMap.en.Project_ActualBudgetProfitability;
    },
    get Project_BudgetedCost() {
        return langMap[ep.resxCulture].Project_BudgetedCost || langMap.en.Project_BudgetedCost;
    },
    get Project_CostVariance() {
        return langMap[ep.resxCulture].Project_CostVariance || langMap.en.Project_CostVariance;
    },
    get Project_EstimatedBudgetProfitability() {
        return langMap[ep.resxCulture].Project_EstimatedBudgetProfitability || langMap.en.Project_EstimatedBudgetProfitability;
    },
    get Project_Expenses() {
        return langMap[ep.resxCulture].Project_Expenses || langMap.en.Project_Expenses;
    },
    get project_info() {
        return langMap[ep.resxCulture].project_info || langMap.en.project_info;
    },
    get Project_InternalCost() {
        return langMap[ep.resxCulture].Project_InternalCost || langMap.en.Project_InternalCost;
    },
    get Project_ProjectBilling() {
        return langMap[ep.resxCulture].Project_ProjectBilling || langMap.en.Project_ProjectBilling;
    },
    get Project_ProjectProfit() {
        return langMap[ep.resxCulture].Project_ProjectProfit || langMap.en.Project_ProjectProfit;
    },
    get Project_ProjectProfitability() {
        return langMap[ep.resxCulture].Project_ProjectProfitability || langMap.en.Project_ProjectProfitability;
    },
    get ProjectArchive() {
        return langMap[ep.resxCulture].ProjectArchive || langMap.en.ProjectArchive;
    },
    get ProjectEndDate_problem() {
        return langMap[ep.resxCulture].ProjectEndDate_problem || langMap.en.ProjectEndDate_problem;
    },
    get Projects() {
        return langMap[ep.resxCulture].Projects || langMap.en.Projects;
    },
    get Projects_Text() {
        return langMap[ep.resxCulture].Projects_Text || langMap.en.Projects_Text;
    },
    get Rename_Text() {
        return langMap[ep.resxCulture].Rename_Text || langMap.en.Rename_Text;
    },
    get Restore_Text() {
        return langMap[ep.resxCulture].Restore_Text || langMap.en.Restore_Text;
    },
    get Save_Text() {
        return langMap[ep.resxCulture].Save_Text || langMap.en.Save_Text;
    },
    get SaveAs_Text() {
        return langMap[ep.resxCulture].SaveAs_Text || langMap.en.SaveAs_Text;
    },
    get Share_Text() {
        return langMap[ep.resxCulture].Share_Text || langMap.en.Share_Text;
    },
    get Shared_With_Me() {
        return langMap[ep.resxCulture].Shared_With_Me || langMap.en.Shared_With_Me;
    },
    get show_archived_projects() {
        return langMap[ep.resxCulture].show_archived_projects || langMap.en.show_archived_projects;
    },
    get Show_Text() {
        return langMap[ep.resxCulture].Show_Text || langMap.en.Show_Text;
    },
    get SortBy_Text() {
        return langMap[ep.resxCulture].SortBy_Text || langMap.en.SortBy_Text;
    },
    get SPI_Problem() {
        return langMap[ep.resxCulture].SPI_Problem || langMap.en.SPI_Problem;
    },
    get SubActivities() {
        return langMap[ep.resxCulture].SubActivities || langMap.en.SubActivities;
    },
    get switchToClassicUI() {
        return langMap[ep.resxCulture].switchToClassicUI || langMap.en.switchToClassicUI;
    },
    get switchToNewUI() {
        return langMap[ep.resxCulture].switchToNewUI || langMap.en.switchToNewUI;
    },
    get tab_Board() {
        return langMap[ep.resxCulture].tab_Board || langMap.en.tab_Board;
    },
    get tab_Calendar() {
        return langMap[ep.resxCulture].tab_Calendar || langMap.en.tab_Calendar;
    },
    get tab_Gantt() {
        return langMap[ep.resxCulture].tab_Gantt || langMap.en.tab_Gantt;
    },
    get tab_Table() {
        return langMap[ep.resxCulture].tab_Table || langMap.en.tab_Table;
    },
    get TargetProfit_warning() {
        return langMap[ep.resxCulture].TargetProfit_warning || langMap.en.TargetProfit_warning;
    },
    get TargetProfitPercentage_warning() {
        return langMap[ep.resxCulture].TargetProfitPercentage_warning || langMap.en.TargetProfitPercentage_warning;
    },
    get TaskEndDate_problem() {
        return langMap[ep.resxCulture].TaskEndDate_problem || langMap.en.TaskEndDate_problem;
    },
    get TaskEndDate_warning() {
        return langMap[ep.resxCulture].TaskEndDate_warning || langMap.en.TaskEndDate_warning;
    },
    get TaskStartDate_warning() {
        return langMap[ep.resxCulture].TaskStartDate_warning || langMap.en.TaskStartDate_warning;
    },
    get Templates_Popup_Title() {
        return langMap[ep.resxCulture].Templates_Popup_Title || langMap.en.Templates_Popup_Title;
    },
    get TimerText() {
        return langMap[ep.resxCulture].TimerText || langMap.en.TimerText;
    },
    get Tools_Menu_Text() {
        return langMap[ep.resxCulture].Tools_Menu_Text || langMap.en.Tools_Menu_Text;
    },
    get Tooltip_DefaultPresetIcon() {
        return langMap[ep.resxCulture].Tooltip_DefaultPresetIcon || langMap.en.Tooltip_DefaultPresetIcon;
    },
    get Tooltip_RevertToDefaultPreset() {
        return langMap[ep.resxCulture].Tooltip_RevertToDefaultPreset || langMap.en.Tooltip_RevertToDefaultPreset;
    },
    get Tooltip_SaveDefaultPreset() {
        return langMap[ep.resxCulture].Tooltip_SaveDefaultPreset || langMap.en.Tooltip_SaveDefaultPreset;
    },
    get Tooltip_SharedByMePreset() {
        return langMap[ep.resxCulture].Tooltip_SharedByMePreset || langMap.en.Tooltip_SharedByMePreset;
    },
    get TotalTargetRevenue_warning() {
        return langMap[ep.resxCulture].TotalTargetRevenue_warning || langMap.en.TotalTargetRevenue_warning;
    },
    get Unarchive_Success_Message() {
        return langMap[ep.resxCulture].Unarchive_Success_Message || langMap.en.Unarchive_Success_Message;
    },
    get uncategorized_tasks() {
        return langMap[ep.resxCulture].uncategorized_tasks || langMap.en.uncategorized_tasks;
    },
    get Unshare_Text() {
        return langMap[ep.resxCulture].Unshare_Text || langMap.en.Unshare_Text;
    },
    get View_Project_Link() {
        return langMap[ep.resxCulture].View_Project_Link || langMap.en.View_Project_Link;
    },
    get WBSNumber_Text() {
        return langMap[ep.resxCulture].WBSNumber_Text || langMap.en.WBSNumber_Text;
    },
    get what_to_export() {
        return langMap[ep.resxCulture].what_to_export || langMap.en.what_to_export;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.activityList = activityListResx;
